import { Flex, Text } from "@jsq/ds/core";
import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { RowItem, TypedAGGridCellRenderParams } from "../types";
import { caseTypeStyle } from "./styles_vanilla.css";
import { mapCaseTypeToText } from "./utils";
interface Props {
  params: TypedAGGridCellRenderParams<RowItem> | { value: ComplianceCaseTypeEnum | string };
}
export const CaseTypeRenderer = ({ params }: Props) => {
  if (typeof params.value !== "string") {
    return null;
  }
  const displayText = mapCaseTypeToText(params.value as ComplianceCaseTypeEnum);
  return (
    <Flex alignItems="center">
      <Text data-testid="case-type" className={caseTypeStyle}></Text>
      {displayText}
    </Flex>
  );
};
